import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { UsersService } from 'src/app/pages/inner-security/services/users.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-whatsapp-fire-notification-modal',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule, MatCardModule],
  templateUrl: './whatsapp-fire-notification-modal.component.html',
  styleUrl: './whatsapp-fire-notification-modal.component.scss'
})
export class WhatsappFireNotificationModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WhatsappFireNotificationModalComponent>,
    private userService: UsersService,
    private notificationService: NotificationsService
    // private factorigService: FactoringOperationsService
  ) {

  }

  UsersForm = new FormControl('');
  UsersList: any[] = [
    { Name: 'Cargando...', Id: '' }
  ];
  public isLoading = false;

  ngOnInit(): void {
    const requestType = this.data.factoringLine > 0 ? "FactoringApprovators" : "WarrantyApprovators";
    this.userService.getUsersByPermission(requestType).subscribe({
      next: (value) => {
        this.UsersList = value.map(x => {
          return { Name: x.firstName + " " + x.lastName, Id: x.rut.split('-')[0] };
        });
      }
    })
    // throw new Error('Method not implemented.');
  }

  public sendNotification() {
    if (this.data.type == "discount") {
      for (let index = 0; index < this.UsersForm.value.length; index++) {
        const userId = this.UsersForm.value[index];
        const postData = {
          templateName: "descuento_pendiente_de_aprobacion",
          to: userId,
          bodyParams: {
            "1": this.data.userName,
            "2": this.data.clientName,
            "3": Math.round(this.data.discountPercentage * 100).toString()
          },
          buttonParam: this.data.salesQuoteId.toString()
        };
        this.notificationService.sendWhatsappNotification(postData).subscribe({
        });
      }
    } else {
      for (let index = 0; index < this.UsersForm.value.length; index++) {
        const userId = this.UsersForm.value[index];
        const postData = {
          templateName: this.data.factoringLine > 0 ? "factoring_minuta_pendiente_de_aprobacion" : "garantias_minuta_pendiente_de_aprobacion",
          to: userId,
          bodyParams: {
            "1": this.data.originator,
            "2": this.data.clientName,
            "3": (this.data.factoringLine + this.data.currentWarrantyLine).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          },
          buttonParam: this.data.minuteId.toString()
        };
        if (this.data.factoringLine == 0 || this.data.factoringLine == null) {
          postData.bodyParams["4"] = this.data.newWarrantyLine.toString();
          postData.bodyParams["5"] = this.data.warrantiesCount.toString();
          postData.bodyParams["6"] = this.data.totalWarranties.toString();
        }
        this.notificationService.sendWhatsappNotification(postData).subscribe({
        });
      }
    }

    Swal.fire({
      icon: 'success',
      title: 'Notificación enviada',
      showConfirmButton: false,
      didDestroy: () => {
        this.dialogRef.close();
      }
    });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
